'use client';
import { useTranslations } from 'next-intl';
import { Stepper } from '@/components/ui/stepper';

/** The new studio owner's two steps (owner decision, 2026-11-03): her account, then the clinic. */
export function OnboardingSteps({ current }: { current: 1 | 2 }) {
  const t = useTranslations('clinicSetup');
  return (
    <Stepper
      className="mb-8"
      steps={[
        { id: 'account', label: t('steps.account') },
        { id: 'clinic', label: t('steps.clinic') },
      ]}
      current={current}
      ariaLabel={t('steps.label')}
      srPosition={t('steps.position', { current, total: 2 })}
    />
  );
}
